import { Link, useRouterState } from '@tanstack/react-router'
import { PortfolioNav, buildPortfolioProducts, type PortfolioNavLink } from '@saas-pages/shared/public/app-shell'
import { resolveUtilitySourceToolKey } from '@saas-pages/shared/public/registry'
import { useT } from '@/shared/i18n'
import { ThemeSwitcher } from '@/shared/theme/theme'
import { buildTools } from '@/shared/tools/tools'
import { LangSwitcher } from '@/widgets/lang-switcher/LangSwitcher'

export function UmbrellaNav() {
  const t = useT()
  const availableTools = buildTools(t).filter((tool) => tool.status === 'available')
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const navItems: PortfolioNavLink[] = [
    ...availableTools.map((tool) => ({
      key: tool.key,
      label: tool.title,
      href: tool.path,
    })),
    { key: 'tools', label: t.nav.allTools, href: '/#tools' },
    { key: 'blog', label: t.nav.blog, href: '/blog' },
  ]

  return (
    <PortfolioNav
      brandLabel="devdeck.ru"
      brandHref="/"
      products={buildPortfolioProducts('devdeck')}
      items={navItems}
      sourceToolKey={resolveUtilitySourceToolKey(availableTools, pathname)}
      actions={(
        <>
          <ThemeSwitcher />
          <LangSwitcher />
        </>
      )}
      renderLink={(link, className, children) => {
        if (link.href.includes('#')) {
          return (
            <a href={link.href} className={className}>
              {children}
            </a>
          )
        }

        return (
          <Link
            to={link.href}
            className={className}
            activeProps={
              link.key === 'brand'
                ? undefined
                : { className: 'bg-accent text-foreground' }
            }
          >
            {children}
          </Link>
        )
      }}
    />
  )
}
